import { DayPicker } from "./DayPicker";
import { useMonthFilter } from "./useMonthFilter";

export function MonthPicker() {
  const { selectedMonth, setSelectedMonth } = useMonthFilter();

  return (
    <DayPicker
      value={selectedMonth}
      onUpdate={(e) => setSelectedMonth(e)}
      label="Месец"
      views={["year", "month"]}
      openTo="month"
      slotProps={{
        textField: {
          variant: "standard",
          sx: { m: 1, width: "100%" },
        },
      }}
    />
  );
}
